var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30564",
    "data-name": "Group 30564",
    transform: "translate(-933 -479)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2732",
    "data-name": "Ellipse 2732",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(933 482)",
    fill: "#15b5d8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(947 504)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBusiness);
export default __webpack_public_path__ + "static/media/AddBusiness.3a38c9683b0cd7c9cf44e9554723bdf5.svg";
export { ForwardRef as ReactComponent };